export const FEATURE_FLAGS_QUERY = `*[_type == "featureToggle" && defined(key)] | order(_updatedAt desc){ key, enabled }`;

export type FeatureFlag = {
  key?: string;
  enabled?: boolean;
};

export function createProviderFlags(flags?: FeatureFlag[] | null): string[] {
  if (!flags?.length) {
    return [];
  }

  const latestFlagsByKey = new Map<string, boolean>();

  flags.forEach((feature) => {
    if (feature.key && !latestFlagsByKey.has(feature.key)) {
      latestFlagsByKey.set(feature.key, feature.enabled ?? false);
    }
  });

  return Array.from(latestFlagsByKey.entries())
    .filter(([, enabled]) => enabled)
    .map(([key]) => key);
}
